declare var settingsReducerState: any; //declared in xhtml template

import { SettingsState } from './../types/redux/SettingsTypes';

/*
 *  IN TEMPLATE! 
 *  const settingsReducerState = {}
 */

export default function settingsReducer(
    state: SettingsState = ( typeof settingsReducerState !== 'undefined' ? settingsReducerState : {} ),
    action: void
): SettingsState {

    return state;

}
